import api from "./api";

interface AudioToggleFavoriteProps {
  audioId: string;
}

interface AudioToggleFavoriteParams {
  audio_id: string;
}

const URL = "/audio/toggle-starred";

// 切换演员收藏状态
export const audioToggleFavorite = async (audioId: AudioToggleFavoriteProps["audioId"]) => {
  const params: AudioToggleFavoriteParams = {
    audio_id: audioId,
  };
  const res = await api.post<unknown>(URL, params);
  return res;
};
